import React, { useEffect, useState } from 'react';
import './NameGroupModal.css';

const NameGroupModal = ({
  isOpen,
  defaultName,
  initialName,
  onConfirm,
  onCancel,
}) => {
  const [value, setValue] = useState(initialName || defaultName || '');

  // sempre que abrir, reseta o valor
  useEffect(() => {
    if (isOpen) {
      setValue(initialName || defaultName || '');
    }
  }, [isOpen, initialName, defaultName]);

  // ESC fecha / Enter salva
  useEffect(() => {
    if (!isOpen) return;

    const handleKey = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onCancel?.();
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        handleSave();
      }
    };

    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, value, defaultName, onConfirm, onCancel]);

  if (!isOpen) return null;

  const handleUseDefault = () => {
    const finalName = defaultName || 'Circuito';
    onConfirm(finalName);
  };

  const handleSave = () => {
    const trimmed = (value || '').trim();
    const finalName = trimmed || defaultName || 'Circuito';
    onConfirm(finalName);
  };

  return (
    <div className="name-group-modal-backdrop">
      <div
        className="name-group-modal card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="name-group-modal-header">
          <h3>Adicionar nome nesse circuito?</h3>
          {onCancel && (
            <button
              type="button"
              className="name-group-modal-close"
              onClick={onCancel}
            >
              ×
            </button>
          )}
        </div>

        <div className="name-group-modal-body">
          <div className="form-group">
            <input
              id="circuit-name-input"
              type="text"
              className="form-control"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={defaultName}
              autoFocus
            />
            <small className="name-group-modal-hint">
              Nome Padrão: <strong>{defaultName}</strong>
            </small>
          </div>
        </div>

        <div className="name-group-modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleUseDefault}
          >
            Usar padrão
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
          >
            Salvar
          </button>
        </div>

        <div className="name-group-modal-shortcuts">
          <span className="text-muted">
            Enter: salvar • Esc: cancelar
          </span>
        </div>
      </div>
    </div>
  );
};

export default NameGroupModal;